import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackOpenedAssetDetails.meta';

export type TrackOpenedAssetDetailsParams = {
  asset_id: string;
  clip_id: string;
};

export const useTrackOpenedAssetDetails = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedAssetDetails = useCallback(
    (params: TrackOpenedAssetDetailsParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackOpenedAssetDetails };
};
